import { createAction, props } from '@ngrx/store';
import { ApiResponseSimple } from 'src/app/shared/models/api-response-simple/ApiResponseSimple';

export const ChangePasswordActionTypes = {
  REQUEST: '[Change Password Page] Request',
  REQUEST_ERROR: '[Change Password Page] Change Password error',
  REQUEST_SUCCESS: '[Change Password Page] Change Password success',
  RESET: '[Change Password Page] Change Password reset'
};

export const ChangePasswordAction = createAction(
  ChangePasswordActionTypes.REQUEST,
  props<{ oldPassword: string; newPassword: string }>()
);

export const ChangePasswordSuccessAction = createAction(
  ChangePasswordActionTypes.REQUEST_SUCCESS,
  props<{ response: ApiResponseSimple }>()
);

export const ChangePasswordErrorAction = createAction(ChangePasswordActionTypes.REQUEST_ERROR, props<{}>());

export const ChangePasswordResetAction = createAction(ChangePasswordActionTypes.RESET);
